/** The server's own message when it sent one, else the transport error, else `fallback`. */
export function errorMessage(error: unknown, fallback: string): string {
  const response = (error as { response?: { data?: { error?: string } } })?.response;
  return response?.data?.error ?? (error as Error)?.message ?? fallback;
}
